import Video from './Video'
export { Video }
export default Video
